<!--添加队员统一模版-->
<template>
  <div>
    <div>
      <div style="margin: 15px;">
        <div style="float:left;font-size:14px"></div>
        <div style="float:right;font-size:14px"></div>
      </div>
    </div>
    <div
      v-if="
        resultXmData !== undefined &&
          resultXmData.BMSET !== undefined &&
          resultXmData.BMSET.length > 0 &&
          resultXmData.BMSET[0].ISKZBM === 'Y'
      "
    >
      <div class="custom-field-group">
        <div class="field-label">
          <span class="required-star">*</span>是否跨组报名
        </div>
        <div class="radio-group">
          <label class="radio-label">
            <input
              type="radio"
              name="iskz"
              value="1"
              v-model="ryInfo.ISKZ.VALUE"
            />
            <span class="radio-text">是</span>
          </label>
          <label class="radio-label">
            <input
              type="radio"
              name="iskz"
              value="0"
              v-model="ryInfo.ISKZ.VALUE"
            />
            <span class="radio-text">否</span>
          </label>
        </div>
      </div>
      <!-- <van-button
            v-if="
              resultXmData !== undefined &&
                resultXmData.BMSET !== undefined &&
                resultXmData.BMSET.length > 0 &&
                resultXmData.BMSET[0].ISKZBM === 'Y'
            "
            style="width:86px;"
            size="small"
            :type="ryInfo.ISKZ.VALUE === '0' ? 'danger' : 'info'"
            @click="kzHandler"
          >
            {{ ryInfo.ISKZ.VALUE === "0" ? "跨组报名" : "取消跨组" }}
          </van-button> -->
    </div>

    <!-- 运动员1信息 开始 -->
    <div>
      <van-row>
        <div style="padding: 11px;">
          <div style="float:left;font-size:14px">
            <label><van-icon name="friends" /> 请填写选手1人员信息</label>
          </div>
          <div style="float:right;font-size:14px">
            <label><span style="color:red">*</span>号为必填</label>
          </div>
        </div>
      </van-row>

      <div style="margin-top:15px">
        <van-field
          v-model="ryInfo.RYXM1.VALUE"
          required
          label="姓名"
          placeholder="请输入姓名"
        >
          <template #button>
            <van-button size="small" type="primary" @click="openModal('1')"
              >选取联系人</van-button
            >
          </template>
        </van-field>
        <div class="custom-field-group">
          <div class="field-label">
            <span class="required-star">*</span>性别
          </div>
          <div class="radio-group">
            <label class="radio-label">
              <input
                type="radio"
                name="xb1"
                value="M"
                v-model="ryInfo.XB1.VALUE"
              />
              <span class="radio-text">男</span>
            </label>
            <label class="radio-label">
              <input
                type="radio"
                name="xb1"
                value="W"
                v-model="ryInfo.XB1.VALUE"
              />
              <span class="radio-text">女</span>
            </label>
          </div>
        </div>
        <van-field
          v-model="ryInfo.TEL1.VALUE"
          type="number"
          :required="
            ssid !==
              '34714f4579684e48716e317451444d796a6d6c62657838425670654842337869'
          "
          label="手机号"
          placeholder="请输入手机号"
        />

        <!--证件类型  开始-->
        <div class="custom-field-group certificate-type-group">
          <div class="field-label">
            <span class="required-star">*</span>证件类型
          </div>
          <div class="radio-group">
            <label class="radio-label">
              <input
                type="radio"
                name="zjlx1"
                value="SFZH"
                v-model="ryInfo.ZJLX1.VALUE"
              />
              <span class="radio-text">大陆身份证</span>
            </label>
            <label
              class="radio-label"
              v-if="
                ssid !==
                  '6f484a687666724b4e5a4168395647696b43514e2b7a515a65504a34466f5549'
              "
            >
              <input
                type="radio"
                name="zjlx1"
                value="GAT"
                v-model="ryInfo.ZJLX1.VALUE"
              />
              <span class="radio-text">港澳台证件</span>
            </label>
            <label
              class="radio-label"
              v-if="
                ssid !==
                  '6f484a687666724b4e5a4168395647696b43514e2b7a515a65504a34466f5549'
              "
            >
              <input
                type="radio"
                name="zjlx1"
                value="QT"
                v-model="ryInfo.ZJLX1.VALUE"
              />
              <span class="radio-text">其他</span>
            </label>
          </div>
        </div>
        <!--证件类型  结束-->

        <div
          v-if="
            resultXmData.BMSET !== undefined &&
              resultXmData.BMSET[0].ISXZCSRQ === '1' &&
              (resultXmData.BMSET[0].ISAGEXZMS === 'TY' ||
                resultXmData.BMSET[0].ISAGEXZMS === 'ARY')
          "
          style="background: #fff;padding: 15px;color: red;"
        >
          <span
            v-if="
              resultXmData.BMSET[0].ISKZBM === 'Y' && ryInfo.ISKZ.VALUE === '1'
            "
          >
            注意：您当前选择的是跨组报名，出生日期需要在：{{
              resultXmData.BMSET[0].KZSTARTDATE1
            }}至{{ resultXmData.BMSET[0].KZENDDATE1 }}范围内
          </span>
          <span v-else>
            注意：出生日期需要在：
            {{ resultXmData.BMSET[0].STARTCSDATE }}
            至
            {{ resultXmData.BMSET[0].ENDCSDATE }}
            范围内
          </span>

          <span v-if="SSLXTYPE === 'D' && resultXmData.ISXZAGEDOUBLE === '1'">
            ，且双方运动员年龄相加必须大于等于：{{ resultXmData.MINAGEHE }}岁，
            小于等于：{{ resultXmData.MAXAGEHE }}岁
          </span>
        </div>

        <div
          v-if="
            resultXmData.BMSET !== undefined &&
              resultXmData.BMSET[0].ISXZCSRQ === '1' &&
              resultXmData.BMSET[0].ISAGEXZMS === 'AXB' &&
              ryInfo.XB1.VALUE.length > 0
          "
          style="background: #fff;padding: 15px;color: red;"
        >
          <span
            v-if="
              resultXmData.BMSET[0].ISKZBM === 'Y' && ryInfo.ISKZ.VALUE === '1'
            "
          >
            注意：您当前选择的是跨组报名，出生日期需要在：{{
              resultXmData.BMSET[0].KZSTARTDATE1
            }}至{{ resultXmData.BMSET[0].KZENDDATE1 }}范围内
          </span>
          <span v-else>
            <span v-if="ryInfo.XB1.VALUE === 'M'">
              注意：男运动员，出生日期需要在：
              {{ resultXmData.BMSET[0].STARTCSDATE }}
              至
              {{ resultXmData.BMSET[0].ENDCSDATE }}
              范围内
            </span>
            <span v-if="ryInfo.XB1.VALUE === 'W'">
              注意：女运动员，出生日期需要在：
              {{ resultXmData.BMSET[0].STARTCSDATE2 }}
              至
              {{ resultXmData.BMSET[0].ENDCSDATE2 }}
              范围内
            </span>
          </span>

          <span v-if="SSLXTYPE === 'D' && resultXmData.ISXZAGEDOUBLE === '1'">
            ，且双方运动员年龄相加必须大于等于：{{ resultXmData.MINAGEHE }}岁，
            小于等于：{{ resultXmData.MAXAGEHE }}岁
          </span>
        </div>

        <van-field
          v-model="ryInfo.SFZH1.VALUE"
          @input="handleInputSfzh1"
          @change="sfzhChangeInputHandler('1')"
          required
          label="证件号码"
          placeholder="请输入证件号码"
        />

        <van-cell
          v-if="ryInfo.ZJLX1.VALUE !== 'SFZH'"
          title="*请选择出生日期"
          :value="ryInfo.SR1.VALUE"
          is-link
          @click="openCsrqShow1"
        />

        <!-- 动态控件部分  开始 -->
        <div>
          <!--动态循环部分 -->

          <div v-for="(item, index) in ryInfo.DTKJLIST1" :key="index">
            <div
              style="padding-left: 15px;padding-right: 15px;"
              v-if="item.KJLX === 'UPLOAD' && item.ISSHOW === '1'"
            >
              <p>
                {{ item.KJMC
                }}<span v-if="item.ISBT === '1'" style="color:red">(必填)</span>
              </p>
              <van-uploader
                :disabled="
                  ryInfo.RYXM1.VALUE.length === 0 ||
                    ryInfo.SFZH1.VALUE.length === 0 ||
                    ryInfo.DWQC.VALUE.length === 0
                "
                v-if="
                  !(item.SHOWTJ === '99999'
                    ? false
                    : item.SHOWTJ === 'DY1'
                    ? ry1YesCount > 0
                    : item.SHOWTJ === 'DY2'
                    ? ry1YesCount > 1
                    : ry1YesCount > 2)
                "
                v-model="item.IMGLIST"
                :max-count="item.COUNT"
                :before-read="beforeRead"
                :after-read="
                  file =>
                    dtFileLoad(
                      file,
                      item.ZDMC,
                      ryInfo.RYXM1.VALUE,
                      ryInfo.SFZH1.VALUE,
                      item
                    )
                "
              />

              <div
                style="color:red;font-size: 14px;"
                v-if="
                  ryInfo.RYXM1.VALUE.length === 0 ||
                    ryInfo.SFZH1.VALUE.length === 0 ||
                    ryInfo.DWQC.VALUE.length === 0
                "
              >
                注意：请输入队伍名称、证件号后方可上传
              </div>
              <div
                style="color:red;font-size: 14px;"
                v-if="
                  item.SHOWTJ === '99999'
                    ? false
                    : item.SHOWTJ === 'DY1'
                    ? ry1YesCount > 0
                    : item.SHOWTJ === 'DY2'
                    ? ry1YesCount > 1
                    : ry1YesCount > 2
                "
              >
                注意：该证件号已经报了{{ ry1YesCount }}个项目，{{
                  item.KJMC
                }}无需填写
              </div>
            </div>
            <div v-if="item.KJLX === 'TEXT' && item.ISSHOW === '1'">
              <van-field
                v-if="item.KJLX === 'TEXT'"
                v-model="item.VALUE"
                :required="item.ISBT === '1'"
                :label="item.KJMC"
                :placeholder="'请输入' + item.KJMC"
                :disabled="
                  item.SHOWTJ === '99999'
                    ? false
                    : item.SHOWTJ === 'DY1'
                    ? ry1YesCount > 0
                    : item.SHOWTJ === 'DY2'
                    ? ry1YesCount > 1
                    : ry1YesCount > 2
                "
              />
              <div
                style="color:red;font-size: 14px;"
                v-if="
                  item.SHOWTJ === '99999'
                    ? false
                    : item.SHOWTJ === 'DY1'
                    ? ry1YesCount > 0
                    : item.SHOWTJ === 'DY2'
                    ? ry1YesCount > 1
                    : ry1YesCount > 2
                "
              >
                注意：该证件号已经报了{{ ry1YesCount }}个项目，{{
                  item.KJMC
                }}无需填写
              </div>
            </div>
            <div
              v-if="item.KJLX === 'SELECT' && item.ISSHOW === '1'"
              style="padding-left: 10px;padding-right: 15px;background: #fff;padding-top: 15px;padding-bottom: 15px;border-bottom: 1px solid #ddd;"
            >
              <span>
                <span style="color:red" v-if="item.ISBT === '1'">*</span>
                {{ item.KJMC }}:
              </span>
              <select
                v-if="
                  !(item.SHOWTJ === '99999'
                    ? false
                    : item.SHOWTJ === 'DY1'
                    ? ry1YesCount > 0
                    : item.SHOWTJ === 'DY2'
                    ? ry1YesCount > 1
                    : ry1YesCount > 2)
                "
                v-model="item.VALUE"
                style="min-width: 45%;height: 25px;margin-left: 22px;font-size: 17px;"
              >
                <option
                  :value="kjItem"
                  v-for="(kjItem, kjIndex) in item.KJJSON"
                  :key="kjIndex"
                  >{{ kjItem }}</option
                >
              </select>
              <div
                style="color:red;font-size: 14px;"
                v-if="
                  item.SHOWTJ === '99999'
                    ? false
                    : item.SHOWTJ === 'DY1'
                    ? ry1YesCount > 0
                    : item.SHOWTJ === 'DY2'
                    ? ry1YesCount > 1
                    : ry1YesCount > 2
                "
              >
                注意：该证件号已经报了{{ ry1YesCount }}个项目，{{
                  item.KJMC
                }}无需填写
              </div>
            </div>
          </div>
          <!--动态循环部分 -->

          <!-- 免冠照  开始 -->
          <div
            style="padding-left: 15px;padding-right: 15px;"
            v-if="resultXmData.ISTXIMG === '1'"
          >
            <p>免冠照<span style="color:red">(必填)</span></p>
            <van-uploader
              :disabled="
                ryInfo.RYXM1.VALUE.length === 0 ||
                  ryInfo.SFZH1.VALUE.length === 0 ||
                  ryInfo.DWQC.VALUE.length === 0
              "
              v-model="ryInfo.MGZIMG1.VALUE"
              :max-count="1"
              :before-read="beforeRead"
              :after-read="mgzImgUpload1"
            />
            <div
              style="color:red;font-size: 14px;"
              v-if="
                ryInfo.RYXM1.VALUE.length === 0 ||
                  ryInfo.SFZH1.VALUE.length === 0 ||
                  ryInfo.DWQC.VALUE.length === 0
              "
            >
              注意：请输入队伍名称、证件号后方可上传
            </div>
          </div>
          <!-- 免冠照  结束 -->
        </div>
        <!-- 动态控件部分 结束 -->
      </div>
    </div>
    <!-- 运动员1信息 结束 -->

    <!-- 运动员2信息 开始 -->
    <div style="margin-top:35px" v-if="SSLXTYPE === 'D'">
      <van-row>
        <div style="padding: 11px;">
          <div style="float:left;font-size:14px">
            <label><van-icon name="friends-o" /> 请填写选手2人员信息</label>
          </div>
          <div style="float:right;font-size:14px">
            <label><span style="color:red">*</span>号为必填</label>
          </div>
        </div>
      </van-row>

      <div style="margin-top:15px">
        <van-field
          v-model="ryInfo.RYXM2.VALUE"
          required
          label="姓名"
          placeholder="请输入姓名"
        >
          <template #button>
            <van-button size="small" type="primary" @click="openModal('2')"
              >选取联系人</van-button
            >
          </template>
        </van-field>
        <div class="custom-field-group">
          <div class="field-label">
            <span class="required-star">*</span>性别
          </div>
          <div class="radio-group">
            <label class="radio-label">
              <input
                type="radio"
                name="xb2"
                value="M"
                v-model="ryInfo.XB2.VALUE"
              />
              <span class="radio-text">男</span>
            </label>
            <label class="radio-label">
              <input
                type="radio"
                name="xb2"
                value="W"
                v-model="ryInfo.XB2.VALUE"
              />
              <span class="radio-text">女</span>
            </label>
          </div>
        </div>
        <van-field
          v-model="ryInfo.TEL2.VALUE"
          type="number"
          :required="
            ssid !==
              '34714f4579684e48716e317451444d796a6d6c62657838425670654842337869'
          "
          label="手机号"
          placeholder="请输入手机号"
        />

        <!--证件类型  开始-->
        <div class="custom-field-group certificate-type-group">
          <div class="field-label">
            <span class="required-star">*</span>证件类型
          </div>
          <div class="radio-group">
            <label class="radio-label">
              <input
                type="radio"
                name="zjlx2"
                value="SFZH"
                v-model="ryInfo.ZJLX2.VALUE"
              />
              <span class="radio-text">大陆身份证</span>
            </label>
            <label class="radio-label">
              <input
                type="radio"
                name="zjlx2"
                value="GAT"
                v-model="ryInfo.ZJLX2.VALUE"
              />
              <span class="radio-text">港澳台证件</span>
            </label>
            <label class="radio-label">
              <input
                type="radio"
                name="zjlx2"
                value="QT"
                v-model="ryInfo.ZJLX2.VALUE"
              />
              <span class="radio-text">其他</span>
            </label>
          </div>
        </div>
        <div
          v-if="
            resultXmData.BMSET !== undefined &&
              resultXmData.BMSET[0].ISXZCSRQ === '1' &&
              (resultXmData.BMSET[0].ISAGEXZMS === 'TY' ||
                resultXmData.BMSET[0].ISAGEXZMS === 'ARY')
          "
          style="background: #fff;padding: 15px;color: red;"
        >
          <span v-if="resultXmData.BMSET[0].ISAGEXZMS === 'TY'">
            注意：{{
              resultXmData.BMSET[0].ISKZBM === "Y" && ryInfo.ISKZ.VALUE === "1"
                ? "您当前选择的是跨组报名，"
                : ""
            }}出生日期需要在：{{
              resultXmData.BMSET[0].ISKZBM === "Y" && ryInfo.ISKZ.VALUE === "1"
                ? resultXmData.BMSET[0].KZSTARTDATE1
                : resultXmData.BMSET[0].STARTCSDATE
            }}至{{
              resultXmData.BMSET[0].ISKZBM === "Y" && ryInfo.ISKZ.VALUE === "1"
                ? resultXmData.BMSET[0].KZENDDATE1
                : resultXmData.BMSET[0].ENDCSDATE
            }}范围内<span
              v-if="SSLXTYPE === 'D' && resultXmData.ISXZAGEDOUBLE === '1'"
              >，且运动员年龄相加必须大于等于：{{ resultXmData.MINAGEHE }}岁，
              小于等于：{{ resultXmData.MAXAGEHE }}岁
            </span>
          </span>
          <span v-if="resultXmData.BMSET[0].ISAGEXZMS !== 'TY'">
            注意：{{
              resultXmData.BMSET[0].ISKZBM === "Y" && ryInfo.ISKZ.VALUE === "1"
                ? "您当前选择的是跨组报名，"
                : ""
            }}出生日期需要在：{{ resultXmData.BMSET[0].STARTCSDATE2 }}至{{
              resultXmData.BMSET[0].ENDCSDATE2
            }}范围内<span
              v-if="SSLXTYPE === 'D' && resultXmData.ISXZAGEDOUBLE === '1'"
              >，且运动员年龄相加必须大于等于：{{ resultXmData.MINAGEHE }}岁，
              小于等于：{{ resultXmData.MAXAGEHE }}岁
            </span>
          </span>
        </div>

        <div
          v-if="
            resultXmData.BMSET !== undefined &&
              resultXmData.BMSET[0].ISXZCSRQ === '1' &&
              resultXmData.BMSET[0].ISAGEXZMS === 'AXB' &&
              ryInfo.XB2.VALUE.length > 0
          "
          style="background: #fff;padding: 15px;color: red;"
        >
          <span
            v-if="
              resultXmData.BMSET[0].ISKZBM === 'Y' && ryInfo.ISKZ.VALUE === '1'
            "
          >
            注意：您当前选择的是跨组报名，出生日期需要在：{{
              resultXmData.BMSET[0].KZSTARTDATE1
            }}至{{ resultXmData.BMSET[0].KZENDDATE1 }}范围内
          </span>
          <span v-else>
            <span v-if="ryInfo.XB2.VALUE === 'M'">
              注意：男运动员，出生日期需要在：
              {{ resultXmData.BMSET[0].STARTCSDATE }}
              至
              {{ resultXmData.BMSET[0].ENDCSDATE }}
              范围内
            </span>
            <span v-if="ryInfo.XB2.VALUE === 'W'">
              注意：女运动员，出生日期需要在：
              {{ resultXmData.BMSET[0].STARTCSDATE2 }}
              至
              {{ resultXmData.BMSET[0].ENDCSDATE2 }}
              范围内
            </span>
          </span>

          <span v-if="SSLXTYPE === 'D' && resultXmData.ISXZAGEDOUBLE === '1'">
            ，且双方运动员年龄相加必须大于等于：{{ resultXmData.MINAGEHE }}岁，
            小于等于：{{ resultXmData.MAXAGEHE }}岁
          </span>
        </div>

        <!--证件类型  结束-->
        <van-field
          v-model="ryInfo.SFZH2.VALUE"
          @input="handleInputSfzh2"
          @change="sfzhChangeInputHandler('2')"
          required
          label="证件号码"
          placeholder="请输入证件号码"
        />
        <van-cell
          v-if="ryInfo.ZJLX2.VALUE !== 'SFZH'"
          title="*请选择出生日期"
          :value="ryInfo.SR2.VALUE"
          is-link
          @click="openCsrqShow2"
        />
        <!-- 动态控件部分  开始 -->
        <div>
          <!--动态循环部分 -->
          <div v-for="(item, index) in ryInfo.DTKJLIST2" :key="index">
            <div
              style="padding-left: 15px;padding-right: 15px;"
              v-if="item.KJLX === 'UPLOAD' && item.ISSHOW === '1'"
            >
              <p>
                {{ item.KJMC
                }}<span v-if="item.ISBT === '1'" style="color:red">(必填)</span>
              </p>
              <van-uploader
                :disabled="
                  ryInfo.RYXM2.VALUE.length === 0 ||
                    ryInfo.SFZH2.VALUE.length === 0 ||
                    ryInfo.DWQC.VALUE.length === 0 ||
                    (item.SHOWTJ === '99999'
                      ? false
                      : item.SHOWTJ === 'DY1'
                      ? ry2YesCount > 0
                      : item.SHOWTJ === 'DY2'
                      ? ry2YesCount > 1
                      : ry2YesCount > 2)
                "
                v-model="item.IMGLIST"
                :max-count="item.COUNT"
                :before-read="beforeRead"
                :after-read="
                  file =>
                    dtFileLoad(
                      file,
                      item.ZDMC,
                      ryInfo.RYXM2.VALUE,
                      ryInfo.SFZH2.VALUE,
                      item
                    )
                "
              />
              <div
                style="color:red;font-size: 14px;"
                v-if="
                  ryInfo.RYXM2.VALUE.length === 0 ||
                    ryInfo.SFZH2.VALUE.length === 0 ||
                    ryInfo.DWQC.VALUE.length === 0
                "
              >
                注意：请输入队伍名称、证件号后方可上传
              </div>
              <div
                style="color:red;font-size: 14px;"
                v-if="
                  item.SHOWTJ === '99999'
                    ? false
                    : item.SHOWTJ === 'DY1'
                    ? ry2YesCount > 0
                    : item.SHOWTJ === 'DY2'
                    ? ry2YesCount > 1
                    : ry2YesCount > 2
                "
              >
                注意：该证件号已经报了{{ ry2YesCount }}个项目，{{
                  item.KJMC
                }}无需填写
              </div>
            </div>
            <div v-if="item.KJLX === 'TEXT' && item.ISSHOW === '1'">
              <van-field
                v-if="item.KJLX === 'TEXT'"
                v-model="item.VALUE"
                :required="item.ISBT === '1'"
                :label="item.KJMC"
                :placeholder="'请输入' + item.KJMC"
                :disabled="
                  item.SHOWTJ === '99999'
                    ? false
                    : item.SHOWTJ === 'DY1'
                    ? ry2YesCount > 0
                    : item.SHOWTJ === 'DY2'
                    ? ry2YesCount > 1
                    : ry2YesCount > 2
                "
              />
              <div
                style="color:red;font-size: 14px;"
                v-if="
                  item.SHOWTJ === '99999'
                    ? false
                    : item.SHOWTJ === 'DY1'
                    ? ry2YesCount > 0
                    : item.SHOWTJ === 'DY2'
                    ? ry2YesCount > 1
                    : ry2YesCount > 2
                "
              >
                注意：该证件号已经报了{{ ry2YesCount }}个项目，{{
                  item.KJMC
                }}无需填写
              </div>
            </div>
            <div
              v-if="item.KJLX === 'SELECT' && item.ISSHOW === '1'"
              style="padding-left: 10px;padding-right: 15px;background: #fff;padding-top: 15px;padding-bottom: 15px;border-bottom: 1px solid #ddd;"
            >
              <span>
                <span style="color:red" v-if="item.ISBT === '1'">*</span>
                {{ item.KJMC }}:
              </span>
              <select
                v-model="item.VALUE"
                style="min-width: 45%;height: 25px;margin-left: 22px;    font-size: 17px;"
                :disabled="
                  item.SHOWTJ === '99999'
                    ? false
                    : item.SHOWTJ === 'DY1'
                    ? ry2YesCount > 0
                    : item.SHOWTJ === 'DY2'
                    ? ry2YesCount > 1
                    : ry2YesCount > 2
                "
              >
                <option
                  :value="kjItem"
                  v-for="(kjItem, kjIndex) in item.KJJSON"
                  :key="kjIndex"
                  >{{ kjItem }}</option
                >
              </select>
              <div
                style="color:red;font-size: 14px;"
                v-if="
                  item.SHOWTJ === '99999'
                    ? false
                    : item.SHOWTJ === 'DY1'
                    ? ry2YesCount > 0
                    : item.SHOWTJ === 'DY2'
                    ? ry2YesCount > 1
                    : ry2YesCount > 2
                "
              >
                注意：该证件号已经报了{{ ry2YesCount }}个项目，{{
                  item.KJMC
                }}无需填写
              </div>
            </div>
          </div>
          <!--动态循环部分 -->

          <div
            style="padding-left: 15px;padding-right: 15px;"
            v-if="resultXmData.ISTXIMG === '1'"
          >
            <p>
              免冠照<span v-if="ryInfo.MGZIMG2.ISBT === '1'" style="color:red"
                >(必填)</span
              >
            </p>
            <van-uploader
              :disabled="
                ryInfo.RYXM2.VALUE.length === 0 ||
                  ryInfo.SFZH2.VALUE.length === 0 ||
                  ryInfo.DWQC.VALUE.length === 0
              "
              v-model="ryInfo.MGZIMG2.VALUE"
              :max-count="1"
              :before-read="beforeRead"
              :after-read="mgzImgUpload2"
            />
            <div
              style="color:red;font-size: 14px;"
              v-if="
                ryInfo.RYXM2.VALUE.length === 0 ||
                  ryInfo.SFZH2.VALUE.length === 0 ||
                  ryInfo.DWQC.VALUE.length === 0
              "
            >
              注意：请输入队伍名称、证件号后方可上传
            </div>
          </div>
        </div>
        <!-- 动态控件部分 结束 -->
      </div>
    </div>
    <!-- 运动员2信息 结束 -->

    <!-- 运动员3信息 开始 -->
    <div
      style="margin-top:35px"
      v-if="SSLX === 'LD' || SSLX === 'GD' || SSLX === 'BD'"
    >
      <van-row>
        <div style="padding: 11px;">
          <div style="float:left;font-size:14px">
            <label><van-icon name="friends-o" /> 请填写选手3人员信息</label>
          </div>
          <div style="float:right;font-size:14px">
            <label><span style="color:red">*</span>号为必填</label>
          </div>
        </div>
      </van-row>

      <div style="margin-top:15px">
        <van-field
          v-model="ryInfo.RYXM3.VALUE"
          required
          label="姓名"
          placeholder="请输入姓名"
        >
          <template #button>
            <van-button size="small" type="primary" @click="openModal('3')"
              >选取联系人</van-button
            >
          </template>
        </van-field>
        <div class="custom-field-group">
          <div class="field-label">
            <span class="required-star">*</span>性别
          </div>
          <div class="radio-group">
            <label class="radio-label">
              <input
                type="radio"
                name="xb3"
                value="M"
                v-model="ryInfo.XB3.VALUE"
              />
              <span class="radio-text">男</span>
            </label>
            <label class="radio-label">
              <input
                type="radio"
                name="xb3"
                value="W"
                v-model="ryInfo.XB3.VALUE"
              />
              <span class="radio-text">女</span>
            </label>
          </div>
        </div>
        <van-field
          v-model="ryInfo.TEL3.VALUE"
          type="number"
          :required="
            ssid !==
              '34714f4579684e48716e317451444d796a6d6c62657838425670654842337869'
          "
          label="手机号"
          placeholder="请输入手机号"
        />

        <!--证件类型  开始-->
        <div class="custom-field-group certificate-type-group">
          <div class="field-label">
            <span class="required-star">*</span>证件类型
          </div>
          <div class="radio-group">
            <label class="radio-label">
              <input
                type="radio"
                name="zjlx3"
                value="SFZH"
                v-model="ryInfo.ZJLX3.VALUE"
              />
              <span class="radio-text">大陆身份证</span>
            </label>
            <label class="radio-label">
              <input
                type="radio"
                name="zjlx3"
                value="GAT"
                v-model="ryInfo.ZJLX3.VALUE"
              />
              <span class="radio-text">港澳台证件</span>
            </label>
            <label class="radio-label">
              <input
                type="radio"
                name="zjlx3"
                value="QT"
                v-model="ryInfo.ZJLX3.VALUE"
              />
              <span class="radio-text">其他</span>
            </label>
          </div>
        </div>
        <div
          v-if="
            resultXmData.BMSET !== undefined &&
              resultXmData.BMSET[0].ISXZCSRQ === '1' &&
              (resultXmData.BMSET[0].ISAGEXZMS === 'TY' ||
                resultXmData.BMSET[0].ISAGEXZMS === 'ARY')
          "
          style="background: #fff;padding: 15px;color: red;"
        >
          <span v-if="resultXmData.BMSET[0].ISAGEXZMS === 'TY'">
            注意：{{
              resultXmData.BMSET[0].ISKZBM === "Y" && ryInfo.ISKZ.VALUE === "1"
                ? "您当前选择的是跨组报名，"
                : ""
            }}出生日期需要在：{{
              resultXmData.BMSET[0].ISKZBM === "Y" && ryInfo.ISKZ.VALUE === "1"
                ? resultXmData.BMSET[0].KZSTARTDATE1
                : resultXmData.BMSET[0].STARTCSDATE
            }}至{{
              resultXmData.BMSET[0].ISKZBM === "Y" && ryInfo.ISKZ.VALUE === "1"
                ? resultXmData.BMSET[0].KZENDDATE1
                : resultXmData.BMSET[0].ENDCSDATE
            }}范围内<span
              v-if="SSLXTYPE === 'D' && resultXmData.ISXZAGEDOUBLE === '1'"
              >，且运动员年龄相加必须大于等于：{{ resultXmData.MINAGEHE }}岁，
              小于等于：{{ resultXmData.MAXAGEHE }}岁
            </span>
          </span>
          <span v-if="resultXmData.BMSET[0].ISAGEXZMS !== 'TY'">
            注意：{{
              resultXmData.BMSET[0].ISKZBM === "Y" && ryInfo.ISKZ.VALUE === "1"
                ? "您当前选择的是跨组报名，"
                : ""
            }}出生日期需要在：{{ resultXmData.BMSET[0].STARTCSDATE3 }}至{{
              resultXmData.BMSET[0].ENDCSDATE3
            }}范围内<span
              v-if="SSLXTYPE === 'D' && resultXmData.ISXZAGEDOUBLE === '1'"
              >，且运动员年龄相加必须大于等于：{{ resultXmData.MINAGEHE }}岁，
              小于等于：{{ resultXmData.MAXAGEHE }}岁
            </span>
          </span>
        </div>
        <div
          v-if="
            resultXmData.BMSET !== undefined &&
              resultXmData.BMSET[0].ISXZCSRQ === '1' &&
              resultXmData.BMSET[0].ISAGEXZMS === 'AXB' &&
              ryInfo.XB3.VALUE.length > 0
          "
          style="background: #fff;padding: 15px;color: red;"
        >
          <span
            v-if="
              resultXmData.BMSET[0].ISKZBM === 'Y' && ryInfo.ISKZ.VALUE === '1'
            "
          >
            注意：您当前选择的是跨组报名，出生日期需要在：{{
              resultXmData.BMSET[0].KZSTARTDATE1
            }}至{{ resultXmData.BMSET[0].KZENDDATE1 }}范围内
          </span>
          <span v-else>
            <span v-if="ryInfo.XB3.VALUE === 'M'">
              注意：男运动员，出生日期需要在：
              {{ resultXmData.BMSET[0].STARTCSDATE }}
              至
              {{ resultXmData.BMSET[0].ENDCSDATE }}
              范围内
            </span>
            <span v-if="ryInfo.XB3.VALUE === 'W'">
              注意：女运动员，出生日期需要在：
              {{ resultXmData.BMSET[0].STARTCSDATE2 }}
              至
              {{ resultXmData.BMSET[0].ENDCSDATE2 }}
              范围内
            </span>
          </span>

          <span v-if="SSLXTYPE === 'D' && resultXmData.ISXZAGEDOUBLE === '1'">
            ，且双方运动员年龄相加必须大于等于：{{ resultXmData.MINAGEHE }}岁，
            小于等于：{{ resultXmData.MAXAGEHE }}岁
          </span>
        </div>
        <!--证件类型  结束-->
        <van-field
          v-model="ryInfo.SFZH3.VALUE"
          @input="handleInputSfzh3"
          @change="sfzhChangeInputHandler('3')"
          required
          label="证件号码"
          placeholder="请输入证件号码"
        />
        <van-cell
          v-if="ryInfo.ZJLX3.VALUE !== 'SFZH'"
          title="*请选择出生日期"
          :value="ryInfo.SR3.VALUE"
          is-link
          @click="openCsrqShow3"
        />
        <!-- 动态控件部分  开始 -->
        <div>
          <!--动态循环部分 -->
          <div v-for="(item, index) in ryInfo.DTKJLIST3" :key="index">
            <div
              style="padding-left: 15px;padding-right: 15px;"
              v-if="item.KJLX === 'UPLOAD' && item.ISSHOW === '1'"
            >
              <p>
                {{ item.KJMC
                }}<span v-if="item.ISBT === '1'" style="color:red">(必填)</span>
              </p>
              <van-uploader
                :disabled="
                  ryInfo.RYXM3.VALUE.length === 0 ||
                    ryInfo.SFZH3.VALUE.length === 0 ||
                    ryInfo.DWQC.VALUE.length === 0 ||
                    (item.SHOWTJ === '99999'
                      ? false
                      : item.SHOWTJ === 'DY1'
                      ? ry3YesCount > 0
                      : item.SHOWTJ === 'DY2'
                      ? ry3YesCount > 1
                      : ry3YesCount > 2)
                "
                v-model="item.IMGLIST"
                :max-count="item.COUNT"
                :before-read="beforeRead"
                :after-read="
                  file =>
                    dtFileLoad(
                      file,
                      item.ZDMC,
                      ryInfo.RYXM3.VALUE,
                      ryInfo.SFZH3.VALUE,
                      item
                    )
                "
              />
              <div
                style="color:red;font-size: 14px;"
                v-if="
                  ryInfo.RYXM3.VALUE.length === 0 ||
                    ryInfo.SFZH3.VALUE.length === 0 ||
                    ryInfo.DWQC.VALUE.length === 0
                "
              >
                注意：请输入队伍名称、证件号后方可上传
              </div>
              <div
                style="color:red;font-size: 14px;"
                v-if="
                  item.SHOWTJ === '99999'
                    ? false
                    : item.SHOWTJ === 'DY1'
                    ? ry3YesCount > 0
                    : item.SHOWTJ === 'DY2'
                    ? ry3YesCount > 1
                    : ry3YesCount > 2
                "
              >
                注意：该证件号已经报了{{ ry3YesCount }}个项目，{{
                  item.KJMC
                }}无需填写
              </div>
            </div>
            <div v-if="item.KJLX === 'TEXT' && item.ISSHOW === '1'">
              <van-field
                v-if="item.KJLX === 'TEXT'"
                v-model="item.VALUE"
                :required="item.ISBT === '1'"
                :label="item.KJMC"
                :placeholder="'请输入' + item.KJMC"
                :disabled="
                  item.SHOWTJ === '99999'
                    ? false
                    : item.SHOWTJ === 'DY1'
                    ? ry3YesCount > 0
                    : item.SHOWTJ === 'DY2'
                    ? ry3YesCount > 1
                    : ry3YesCount > 2
                "
              />
              <div
                style="color:red;font-size: 14px;"
                v-if="
                  item.SHOWTJ === '99999'
                    ? false
                    : item.SHOWTJ === 'DY1'
                    ? ry3YesCount > 0
                    : item.SHOWTJ === 'DY2'
                    ? ry3YesCount > 1
                    : ry3YesCount > 2
                "
              >
                注意：该证件号已经报了{{ ry3YesCount }}个项目，{{
                  item.KJMC
                }}无需填写
              </div>
            </div>
            <div
              v-if="item.KJLX === 'SELECT' && item.ISSHOW === '1'"
              style="padding-left: 10px;padding-right: 15px;background: #fff;padding-top: 15px;padding-bottom: 15px;border-bottom: 1px solid #ddd;"
            >
              <span>
                <span style="color:red" v-if="item.ISBT === '1'">*</span>
                {{ item.KJMC }}:
              </span>
              <select
                v-model="item.VALUE"
                style="min-width: 45%;height: 25px;margin-left: 22px;    font-size: 17px;"
                :disabled="
                  item.SHOWTJ === '99999'
                    ? false
                    : item.SHOWTJ === 'DY1'
                    ? ry3YesCount > 0
                    : item.SHOWTJ === 'DY2'
                    ? ry3YesCount > 1
                    : ry3YesCount > 2
                "
              >
                <option
                  :value="kjItem"
                  v-for="(kjItem, kjIndex) in item.KJJSON"
                  :key="kjIndex"
                  >{{ kjItem }}</option
                >
              </select>
              <div
                style="color:red;font-size: 14px;"
                v-if="
                  item.SHOWTJ === '99999'
                    ? false
                    : item.SHOWTJ === 'DY1'
                    ? ry3YesCount > 0
                    : item.SHOWTJ === 'DY2'
                    ? ry3YesCount > 1
                    : ry3YesCount > 2
                "
              >
                注意：该证件号已经报了{{ ry3YesCount }}个项目，{{
                  item.KJMC
                }}无需填写
              </div>
            </div>
          </div>
          <!--动态循环部分 -->

          <div
            style="padding-left: 15px;padding-right: 15px;"
            v-if="resultXmData.ISTXIMG === '1'"
          >
            <p>
              免冠照<span v-if="ryInfo.MGZIMG3.ISBT === '1'" style="color:red"
                >(必填)</span
              >
            </p>
            <van-uploader
              :disabled="
                ryInfo.RYXM3.VALUE.length === 0 ||
                  ryInfo.SFZH3.VALUE.length === 0 ||
                  ryInfo.DWQC.VALUE.length === 0
              "
              v-model="ryInfo.MGZIMG3.VALUE"
              :max-count="1"
              :before-read="beforeRead"
              :after-read="mgzImgUpload3"
            />
            <div
              style="color:red;font-size: 14px;"
              v-if="
                ryInfo.RYXM3.VALUE.length === 0 ||
                  ryInfo.SFZH3.VALUE.length === 0 ||
                  ryInfo.DWQC.VALUE.length === 0
              "
            >
              注意：请输入队伍名称、证件号后方可上传
            </div>
          </div>
        </div>
        <!-- 动态控件部分 结束 -->
      </div>
    </div>
    <!-- 运动员3信息 结束 -->

    <!-- 选取联系人弹出框 开始-->
    <van-action-sheet v-model="selectLxrShow" title="请选择联系人">
      <div>
        <div style="padding-left: 15px;padding-right: 15px;color: red;">
          注意：如果列表没有您的运动员，可直接输入相应的信息进行报名
        </div>
        <van-field
          v-model="search.info"
          left-icon="search"
          center
          clearable
          label=""
          placeholder="请输入信息"
        >
          <template #button>
            <van-button size="small" type="primary" @click="searchHandler"
              >检索</van-button
            >
          </template>
        </van-field>
        <van-cell
          v-for="(item, index) in connectList"
          :key="index"
          :title="item.RYXM"
          :value="item.TEL"
          is-link
          @click="selectItemConnect(item)"
        />
        <div
          style="text-align: center;margin-top: 15px;font-size:13px;color:rgb(104, 104, 104)"
          @click="loadingGdHandler"
          v-if="connectList.length > 0"
        >
          <span>{{ isEndPage ? "已加载全部" : "点击加载更多" }}</span>
          <van-icon name="arrow-down" v-if="!isEndPage" />
        </div>
        <div style="width:15px;height:50px;"></div>
      </div>
    </van-action-sheet>
    <!-- 选取联系人弹出框 结束-->

    <!-- 运动员1出生日期 开始-->
    <van-action-sheet v-model="csrq1Show" title="请选择球员1出生日期">
      <div>
        <van-datetime-picker
          :min-date="minDate"
          type="date"
          @confirm="getSr1Data"
        />
      </div>
    </van-action-sheet>
    <!-- 运动员1出生日期 结束-->
    <!-- 运动员2出生日期 开始-->
    <van-action-sheet v-model="csrq2Show" title="请选择球员2出生日期">
      <div>
        <van-datetime-picker
          :min-date="minDate"
          type="date"
          @confirm="getSr2Data"
        />
      </div>
    </van-action-sheet>
    <!-- 运动员2出生日期 结束-->

    <!-- 运动员3出生日期 开始-->
    <van-action-sheet v-model="csrq3Show" title="请选择球员3出生日期">
      <div>
        <van-datetime-picker
          :min-date="minDate"
          type="date"
          @confirm="getSr3Data"
        />
      </div>
    </van-action-sheet>
    <!-- 运动员3出生日期 结束-->
  </div>
</template>

<script>
import axios from "axios";
import { ImagePreview } from "vant";
import LoadingCom from "./LoadingCom.vue";

export default {
  components: { LoadingCom },
  name: "ReportRyInfoCom",
  props: {
    ryInfo: {
      type: Object,
      default: null
    },
    utilPost: {
      type: Object,
      default: null
    },
    setValueFn: {
      //父控件中的加载数据方法
      type: Function,
      default: null
    },
    SSLXTYPE: {
      type: String,
      default: ""
    },
    XBTYPE: {
      type: String,
      default: ""
    },
    SSLX: {
      type: String,
      default: ""
    },
    ssid: {
      type: String,
      default: ""
    },
    resultXmData: {
      type: Object,
      default: null
    },
    XMID: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      minDate: new Date(1900, 0, 1), // 1900年1月1日
      csrq1Show: false,
      csrq2Show: false,
      csrq3Show: false,
      value1: 0,
      value2: "a",
      option1: [
        { text: "全部商品", value: 0 },
        { text: "新款商品", value: 1 },
        { text: "活动商品", value: 2 }
      ],
      selectLxrShow: false,
      setType: "",
      tempMGZIMG1: [],
      isFzcmImgShow: false,
      pageSet: {
        currentPage: 1, //当前页页码
        pageSize: 20, //每页默认显示的条数
        totalNums: 0 //数据总条数
      },
      search: {
        info: ""
      },
      connectList: [],
      isEndPage: false,
      ry1YesCount: 0,
      ry2YesCount: 0,
      ry3YesCount: 0
    };
  },
  created() {
    //document.getElementsByTagName("html")[0].style.fontSize = "14px";
    this.utilPost = this.$util.handler;
  },
  mounted() {
    this.utilPost = this.$util.handler;
    this.getMyConnect();
    // 保存取消监听函数
    const unwatch = this.$watch(
      "ryInfo",
      val => {
        // 你的原有业务逻辑
        if (val && val.SFZH1.VALUE.length > 0) {
          this.$nextTick(() => {
            this.sfzhChangeInputHandler("1");
          });
        }
        if (val && val.SFZH2.VALUE.length > 0) {
          this.$nextTick(() => {
            this.sfzhChangeInputHandler("2");
          });
        }
        if (val && val.SFZH3.VALUE.length > 0) {
          this.$nextTick(() => {
            this.sfzhChangeInputHandler("3");
          });
        }
        // 执行一次后，直接销毁监听，彻底不再触发
        if (unwatch) {
          unwatch();
        }
      },
      { deep: true, immediate: true }
    );
  },
  methods: {
    /**
     * 图片压缩方法
     * @param {File|Object} file - 原始图片文件或Vant包装对象
     * @param {Object} options - 压缩配置
     * @returns {Promise<File>} 压缩后的图片文件
     */
    compressImage(file, options = {}) {
      return new Promise((resolve, reject) => {
        // 处理Vant uploader传入的对象格式
        let actualFile = file;
        if (file && file.file) {
          actualFile = file.file; // Vant uploader包装的file对象
        }

        // 验证文件类型
        if (!actualFile || !(actualFile instanceof Blob)) {
          reject(new Error("无效的文件对象"));
          return;
        }

        // 默认配置
        const defaultOptions = {
          maxWidth: 1920, // 最大宽度
          maxHeight: 1920, // 最大高度
          quality: 0.8, // 压缩质量 0-1
          mimeType: actualFile.type || "image/jpeg" // 输出格式
        };
        const config = { ...defaultOptions, ...options };

        // 如果文件小于100KB，直接返回原文件
        if (actualFile.size < 100 * 1024) {
          resolve(actualFile);
          return;
        }

        const reader = new FileReader();
        reader.readAsDataURL(actualFile);
        reader.onload = e => {
          const img = new Image();
          img.src = e.target.result;
          img.onload = () => {
            // 计算压缩后的尺寸
            let width = img.width;
            let height = img.height;

            // 如果图片尺寸超过最大值，等比例缩放
            if (width > config.maxWidth || height > config.maxHeight) {
              const ratio = Math.min(
                config.maxWidth / width,
                config.maxHeight / height
              );
              width = width * ratio;
              height = height * ratio;
            }

            // 创建canvas进行压缩
            const canvas = document.createElement("canvas");
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext("2d");

            // 使用更好的图像平滑算法
            ctx.imageSmoothingEnabled = true;
            ctx.imageSmoothingQuality = "high";

            // 绘制图片
            ctx.drawImage(img, 0, 0, width, height);

            // 转换为Blob
            canvas.toBlob(
              blob => {
                if (!blob) {
                  reject(new Error("图片压缩失败"));
                  return;
                }

                // 创建新的File对象
                const compressedFile = new File(
                  [blob],
                  actualFile.name || "image.jpg",
                  {
                    type: config.mimeType,
                    lastModified: Date.now()
                  }
                );

                // 打印压缩信息（可选）
                console.log(
                  `图片压缩: ${(actualFile.size / 1024).toFixed(2)}KB -> ${(
                    compressedFile.size / 1024
                  ).toFixed(2)}KB, 压缩率: ${(
                    (1 - compressedFile.size / actualFile.size) *
                    100
                  ).toFixed(2)}%`
                );

                resolve(compressedFile);
              },
              config.mimeType,
              config.quality
            );
          };
          img.onerror = () => {
            reject(new Error("图片加载失败"));
          };
        };
        reader.onerror = () => {
          reject(new Error("文件读取失败"));
        };
      });
    },

    kzHandler() {
      if (
        this.ryInfo.ISKZ.VALUE.length === 0 ||
        this.ryInfo.ISKZ.VALUE === "0"
      ) {
        this.ryInfo.ISKZ.VALUE = "1";
      } else {
        this.ryInfo.ISKZ.VALUE = "0";
      }
    },
    openCsrqShow1() {
      this.csrq1Show = true;
    },
    openCsrqShow2() {
      this.csrq2Show = true;
    },
    openCsrqShow3() {
      this.csrq3Show = true;
    },
    getSr1Data(date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0"); // 补零
      const day = date
        .getDate()
        .toString()
        .padStart(2, "0"); // 补零
      this.ryInfo.SR1.VALUE = `${year}-${month}-${day}`;
      this.csrq1Show = false;
    },
    getSr2Data(date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0"); // 补零
      const day = date
        .getDate()
        .toString()
        .padStart(2, "0"); // 补零
      this.ryInfo.SR2.VALUE = `${year}-${month}-${day}`;
      this.csrq2Show = false;
    },
    getSr3Data(date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0"); // 补零
      const day = date
        .getDate()
        .toString()
        .padStart(2, "0"); // 补零
      this.ryInfo.SR3.VALUE = `${year}-${month}-${day}`;
      this.csrq3Show = false;
    },
    handleInputSfzh1(value) {
      this.ryInfo.SFZH1.VALUE = value.replace(/[^A-Za-z0-9]/g, "");
    },
    handleInputSfzh2(value) {
      this.ryInfo.SFZH2.VALUE = value.replace(/[^A-Za-z0-9]/g, "");
    },
    handleInputSfzh3(value) {
      this.ryInfo.SFZH3.VALUE = value.replace(/[^A-Za-z0-9]/g, "");
    },
    searchHandler() {
      this.connectList = [];
      this.pageSet.currentPage = 1;
      this.getMyConnect();
    },
    getMyConnect() {
      var busData = {
        pageSet: this.pageSet,
        search: this.search
      };
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: this.op, //反射名称
          methodName: "getMyConnect" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      //alert(JSON.stringify(paramData));
      this.utilPost.sendPost().then(data => {
        if (!data.isSuccess) {
          alert(data.msg);
          return;
        }
        if (
          data.content.length == 0 ||
          data.totalCount === this.pageSet.currentPage
        ) {
          this.isEndPage = true;
        } else {
          this.isEndPage = false;
        }
        for (var i = 0; i < data.content.length; i++) {
          this.connectList.push(data.content[i]);
        }
      });
    },
    loadingGdHandler() {
      if (this.isEndPage) {
        return;
      }
      this.pageSet.currentPage = this.pageSet.currentPage + 1;
      this.getMyConnect();
    },
    //预览图片
    getImg(images, index) {
      ImagePreview({
        images: images,
        showIndex: true,
        loop: false,
        startPosition: index
      });
    },
    openModal(setType) {
      this.selectLxrShow = true;
      this.setType = setType;
    },
    selectItemConnect(item) {
      var busData = {
        SFZH: item.SFZH
      };
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: this.op, //反射名称
          methodName: "getSfzhYbmCount" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      //alert(JSON.stringify(paramData));
      this.utilPost.sendPost().then(data => {
        if (!data.isSuccess) {
          alert(data.msg);
          return;
        }
        const ryCount = data.content - 0;
        if (this.setType === "1") {
          this.ryInfo.RYXM1.VALUE = item.RYXM;
          this.ryInfo.XB1.VALUE = item.XB;
          this.ryInfo.TEL1.VALUE = item.TEL;
          this.ryInfo.SFZH1.VALUE = item.SFZH;
          this.ryInfo.ZJLX1.VALUE = item.ZJLX;
          this.ry1YesCount = ryCount;
          this.checkDyZjIsValue("1");
        } else if (this.setType === "2") {
          this.ryInfo.RYXM2.VALUE = item.RYXM;
          this.ryInfo.XB2.VALUE = item.XB;
          this.ryInfo.TEL2.VALUE = item.TEL;
          this.ryInfo.SFZH2.VALUE = item.SFZH;
          this.ryInfo.ZJLX2.VALUE = item.ZJLX;
          this.ry2YesCount = ryCount;
          this.checkDyZjIsValue("2");
        } else {
          this.ryInfo.RYXM3.VALUE = item.RYXM;
          this.ryInfo.XB3.VALUE = item.XB;
          this.ryInfo.TEL3.VALUE = item.TEL;
          this.ryInfo.SFZH3.VALUE = item.SFZH;
          this.ryInfo.ZJLX3.VALUE = item.ZJLX;
          this.ry3YesCount = ryCount;
          this.checkDyZjIsValue("3");
        }
        this.selectLxrShow = false;
      });
    },

    sfzhChangeInputHandler(type) {
      let SFZH = "";
      switch (type) {
        case "1": {
          SFZH = this.ryInfo.SFZH1.VALUE;
          break;
        }
        case "2": {
          SFZH = this.ryInfo.SFZH2.VALUE;
          break;
        }
        case "3": {
          SFZH = this.ryInfo.SFZH3.VALUE;
          break;
        }
      }
      let XMID = "";
      if (this.XMID) {
        XMID = this.XMID;
      }
      var busData = {
        SFZH: SFZH,
        XMID: XMID
      };
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: this.op, //反射名称
          methodName: "getSfzhYbmCount" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      //alert(JSON.stringify(paramData));
      this.utilPost.sendPost().then(data => {
        if (!data.isSuccess) {
          alert(data.msg);
          return;
        }
        const ryCount = data.content - 0;
        if (type === "1") {
          this.ry1YesCount = ryCount;
          this.checkDyZjIsValue("1");
        } else if (type === "2") {
          this.ry2YesCount = ryCount;
          this.checkDyZjIsValue("2");
        } else {
          this.ry3YesCount = ryCount;
          this.checkDyZjIsValue("3");
        }
      });
    },

    checkDyZjIsValue(sy) {
      let DTKJLIST = [];
      let yesBmCount = 0;
      if (sy === "1") {
        DTKJLIST = this.ryInfo.DTKJLIST1;
        yesBmCount = this.ry1YesCount;
      } else if (sy === "2") {
        DTKJLIST = this.ryInfo.DTKJLIST2;
        yesBmCount = this.ry2YesCount;
      } else if (sy === "3") {
        DTKJLIST = this.ryInfo.DTKJLIST3;
        yesBmCount = this.ry3YesCount;
      }
      for (let i = 0; i < DTKJLIST.length; i++) {
        let kjItem = DTKJLIST[i];
        let KJLX = kjItem.KJLX;
        let SHOWTJ = kjItem.SHOWTJ;
        if (SHOWTJ !== "99999") {
          let isN = "0";
          switch (SHOWTJ) {
            case "DY1": {
              if (yesBmCount > 0) {
                isN = "1";
              }
              break;
            }
            case "DY2": {
              if (yesBmCount > 1) {
                isN = "1";
              }
              break;
            }
            case "DY3": {
              if (yesBmCount > 2) {
                isN = "1";
              }
              break;
            }
          }
          if (isN === "1") {
            if (KJLX === "UPLOAD") {
              let isYesValue = false;
              for (let p = 0; p < kjItem.IMGLIST.length; p++) {
                let filePath = kjItem.IMGLIST[p].filePath;
                if (filePath !== "-") {
                  if (sy === "1") {
                    this.ry1YesCount = 0;
                  } else if (sy === "2") {
                    this.ry2YesCount = 0;
                  } else if (sy === "3") {
                    this.ry3YesCount = 0;
                  }
                  isYesValue = true;
                  continue;
                }
              }

              if (isYesValue) {
                continue;
              }

              kjItem.IMGLIST = [];
              let item = {
                url: "-",
                filePath: "-",
                filePath_ys: "-"
              };
              kjItem.IMGLIST.push(item);
            } else {
              if (kjItem.VALUE !== "-") {
                if (sy === "1") {
                  this.ry1YesCount = 0;
                } else if (sy === "2") {
                  this.ry2YesCount = 0;
                } else if (sy === "3") {
                  this.ry3YesCount = 0;
                }
                continue;
              } else {
                kjItem.VALUE = "-";
              }
            }
          }
        }
      }
    },

    /**人员1 免冠照上传 */
    async mgzImgUpload1(file) {
      try {
        // 提取实际的文件对象
        let actualFile = file;
        if (file && file.file) {
          actualFile = file.file;
        }

        // 压缩图片
        const compressedFile = await this.compressImage(actualFile, {
          maxWidth: 1920,
          maxHeight: 1920,
          quality: 0.85
        });

        // 将 File 对象包装成 Vant 需要的格式
        const wrappedFile = {
          file: compressedFile,
          content: await this.fileToDataURL(compressedFile)
        };

        this.utilPost
          .uploadImg(
            wrappedFile,
            "MGZIMG" +
              "々" +
              this.ssid +
              "々" +
              this.ryInfo.DWQC.VALUE +
              "々" +
              this.ryInfo.RYXM1.VALUE +
              "々" +
              this.ryInfo.SFZH1.VALUE
          )
          .then(data => {
            if (data.isSuccess) {
              var fileList = JSON.parse(
                JSON.stringify(this.ryInfo.MGZIMG1.VALUE)
              );
              var itemFile = {
                url: data.content.url,
                filePath: data.content.filePath,
                filePath_ys: data.content.filePath_ys
              };
              this.ryInfo.MGZIMG1.VALUE = [];
              for (var i = 0; i < fileList.length; i++) {
                var keys = Object.keys(fileList[i]);
                if (keys.length === 3) {
                  this.ryInfo.MGZIMG1.VALUE.push(fileList[i]);
                }
              }
              this.ryInfo.MGZIMG1.VALUE.push(itemFile);
              this.setValueFn(false);
            } else {
              alert(data.msg);
              this.setValueFn(false);
            }
          })
          .catch(error => {
            alert("上传失败：" + error.message);
            this.setValueFn(false);
          });
      } catch (error) {
        alert("图片压缩失败：" + error.message);
        this.setValueFn(false);
      }
    },

    /**
     * 将 File 转换为 DataURL
     */
    fileToDataURL(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = e => resolve(e.target.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },

    /**人员2 免冠照上传 */
    async mgzImgUpload2(file) {
      try {
        // 提取实际的文件对象
        let actualFile = file;
        if (file && file.file) {
          actualFile = file.file;
        }

        // 压缩图片
        const compressedFile = await this.compressImage(actualFile, {
          maxWidth: 1920,
          maxHeight: 1920,
          quality: 0.85
        });

        // 将 File 对象包装成 Vant 需要的格式
        const wrappedFile = {
          file: compressedFile,
          content: await this.fileToDataURL(compressedFile)
        };

        this.utilPost
          .uploadImg(
            wrappedFile,
            "MGZIMG" +
              "々" +
              this.ssid +
              "々" +
              this.ryInfo.DWQC.VALUE +
              "々" +
              this.ryInfo.RYXM2.VALUE +
              "々" +
              this.ryInfo.SFZH2.VALUE
          )
          .then(data => {
            if (data.isSuccess) {
              var fileList = JSON.parse(
                JSON.stringify(this.ryInfo.MGZIMG2.VALUE)
              );
              var itemFile = {
                url: data.content.url,
                filePath: data.content.filePath,
                filePath_ys: data.content.filePath_ys
              };
              this.ryInfo.MGZIMG2.VALUE = [];
              for (var i = 0; i < fileList.length; i++) {
                var keys = Object.keys(fileList[i]);
                if (keys.length === 3) {
                  this.ryInfo.MGZIMG2.VALUE.push(fileList[i]);
                }
              }
              this.ryInfo.MGZIMG2.VALUE.push(itemFile);
              this.setValueFn(false);
            } else {
              alert(data.msg);
              this.setValueFn(false);
            }
          })
          .catch(error => {
            alert("上传失败：" + error.message);
            this.setValueFn(false);
          });
      } catch (error) {
        alert("图片压缩失败：" + error.message);
        this.setValueFn(false);
      }
    },
    async mgzImgUpload3(file) {
      try {
        // 提取实际的文件对象
        let actualFile = file;
        if (file && file.file) {
          actualFile = file.file;
        }

        // 压缩图片
        const compressedFile = await this.compressImage(actualFile, {
          maxWidth: 1920,
          maxHeight: 1920,
          quality: 0.85
        });

        // 将 File 对象包装成 Vant 需要的格式
        const wrappedFile = {
          file: compressedFile,
          content: await this.fileToDataURL(compressedFile)
        };

        this.utilPost
          .uploadImg(
            wrappedFile,
            "MGZIMG" +
              "々" +
              this.ssid +
              "々" +
              this.ryInfo.DWQC.VALUE +
              "々" +
              this.ryInfo.RYXM3.VALUE +
              "々" +
              this.ryInfo.SFZH3.VALUE
          )
          .then(data => {
            if (data.isSuccess) {
              var fileList = JSON.parse(
                JSON.stringify(this.ryInfo.MGZIMG3.VALUE)
              );
              var itemFile = {
                url: data.content.url,
                filePath: data.content.filePath,
                filePath_ys: data.content.filePath_ys
              };
              this.ryInfo.MGZIMG3.VALUE = [];
              for (var i = 0; i < fileList.length; i++) {
                var keys = Object.keys(fileList[i]);
                if (keys.length === 3) {
                  this.ryInfo.MGZIMG3.VALUE.push(fileList[i]);
                }
              }
              this.ryInfo.MGZIMG3.VALUE.push(itemFile);
              this.setValueFn(false);
            } else {
              alert(data.msg);
              this.setValueFn(false);
            }
          })
          .catch(error => {
            alert("上传失败：" + error.message);
            this.setValueFn(false);
          });
      } catch (error) {
        alert("图片压缩失败：" + error.message);
        this.setValueFn(false);
      }
    },
    beforeRead() {
      this.setValueFn(true);
      return true;
    },
    //动态图片部分
    async dtFileLoad(file, zdmc, ryxm, sfzh, item) {
      try {
        // 提取实际的文件对象
        let actualFile = file;
        if (file && file.file) {
          actualFile = file.file;
        }

        // 压缩图片
        const compressedFile = await this.compressImage(actualFile, {
          maxWidth: 1920,
          maxHeight: 1920,
          quality: 0.85
        });

        // 将 File 对象包装成 Vant 需要的格式
        const wrappedFile = {
          file: compressedFile,
          content: await this.fileToDataURL(compressedFile)
        };

        this.utilPost
          .uploadImg(
            wrappedFile,
            zdmc +
              "々" +
              this.ssid +
              "々" +
              this.ryInfo.DWQC.VALUE +
              "々" +
              ryxm +
              "々" +
              sfzh
          )
          .then(data => {
            if (data.isSuccess) {
              var fileList = JSON.parse(JSON.stringify(item.IMGLIST));
              var itemFile = {
                url: data.content.url,
                filePath: data.content.filePath,
                filePath_ys: data.content.filePath_ys
              };
              item.IMGLIST = [];
              for (var i = 0; i < fileList.length; i++) {
                var keys = Object.keys(fileList[i]);
                if (keys.length === 3) {
                  item.IMGLIST.push(fileList[i]);
                }
              }
              item.IMGLIST.push(itemFile);
              this.setValueFn(false);
            } else {
              item.IMGLIST = [];
              alert(data.msg);
              this.setValueFn(false);
            }
          })
          .catch(error => {
            item.IMGLIST = [];
            alert("上传失败：" + error.message);
            this.setValueFn(false);
          });
      } catch (error) {
        item.IMGLIST = [];
        alert("图片压缩失败：" + error.message);
        this.setValueFn(false);
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.itemContentMain {
  margin-top: 15px;
  background: #fff;
  margin-left: 15px;
  margin-right: 15px;
  border-radius: 5px;
}
.van-image__img {
  border-top-right-radius: 5px !important;
  border-top-left-radius: 5px !important;
}
.textMainDiv {
  border-bottom: 1px solid #ebedf0;
  text-align: left;
  padding-left: 15px;
  padding-bottom: 15px;
}
.textMainDiv div {
  margin-top: 5px;
}
.textFotter {
  text-align: left;
}
</style>

<style scoped>
/* 🎨 运动员信息组件美化样式 */

/* 分隔横幅 */
.van-row {
  background: linear-gradient(
    135deg,
    rgba(24, 95, 155, 0.05) 0%,
    rgba(34, 115, 175, 0.05) 100%
  );
  border-radius: 8px;
  margin: 10px;
}

.van-row > div {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.van-row label {
  display: flex;
  align-items: center;
  font-weight: 500;
  color: rgb(24, 95, 155);
}

.van-row .van-icon {
  margin-right: 6px;
  font-size: 18px;
}

.van-row span[style*="color:red"] {
  color: #ff4444 !important;
  font-weight: 700;
}

/* 输入框美化 */
.van-field {
  border-bottom: 1px solid #f0f0f0;
}

.van-field:hover {
  background: #fafafa;
}

.van-field >>> .van-field__label {
  color: #666;
  font-weight: 500;
}

.van-field >>> .van-field__control {
  color: #2c3e50;
}

.van-field >>> .van-field__control::placeholder {
  color: #999;
}

/* 必填标记 */
.van-field[required] >>> .van-field__label::after {
  content: " *";
  color: #ff4444;
  font-weight: 700;
}

/* 选取联系人按钮 */
.van-field >>> .van-button--primary {
  background: linear-gradient(
    135deg,
    rgb(24, 95, 155) 0%,
    rgb(34, 115, 175) 100%
  );
  border: none;
  border-radius: 6px;
  font-weight: 500;
  box-shadow: 0 2px 8px rgba(24, 95, 155, 0.3);
}

.van-field >>> .van-button--primary:active {
  transform: scale(0.95);
  box-shadow: 0 1px 4px rgba(24, 95, 155, 0.3);
}

/* 原生单选按钮组样式 */
.custom-field-group {
  background: #fff;
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  gap: 16px;
}

.field-label {
  font-size: 14px;
  color: #666;
  font-weight: 500;
  flex-shrink: 0;
  min-width: 80px;
}

.field-label .required-star {
  color: #ff4444;
  font-weight: 700;
  margin-right: 4px;
}

.radio-group {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 16px;
  flex: 1;
}

.radio-label {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}

.radio-label input[type="radio"] {
  width: 18px;
  height: 18px;
  margin: 0;
  margin-right: 6px;
  cursor: pointer;
  accent-color: rgb(24, 95, 155);
}

.radio-label .radio-text {
  font-size: 14px;
  color: #2c3e50;
  font-weight: 500;
}

.radio-label:hover .radio-text {
  color: rgb(24, 95, 155);
}

.radio-label input[type="radio"]:checked + .radio-text {
  color: rgb(24, 95, 155);
  font-weight: 600;
}

/* 证件类型特殊布局 - 垂直排列并允许换行 */
.certificate-type-group {
  flex-direction: column;
  align-items: flex-start;
}

.certificate-type-group .field-label {
  min-width: auto;
}

.certificate-type-group .radio-group {
  flex-wrap: wrap;
  width: 100%;
}

/* 提示信息框 */
div[style*="color: red"] {
  background: linear-gradient(135deg, #fff3f3 0%, #ffe5e5 100%);
  border-left: 4px solid #ff4444;
  border-radius: 8px;
  margin-top: 5px;
  margin-bottom: 10px;
  margin-left: 0px;
  margin-right: 0px;
  padding: 6px !important;
  color: #ff4444 !important;
  font-size: 13px;
  line-height: 1.6;
  box-shadow: 0 2px 8px rgba(255, 68, 68, 0.1);
}

/* 上传图片区域 */
.van-uploader {
  margin: 10px 0;
}

.van-uploader >>> .van-uploader__upload {
  border: 2px dashed rgb(24, 95, 155);
  border-radius: 8px;
  background: rgba(24, 95, 155, 0.05);
}

.van-uploader >>> .van-uploader__upload:hover {
  border-color: rgb(34, 115, 175);
  background: rgba(24, 95, 155, 0.1);
}

.van-uploader >>> .van-uploader__upload-icon {
  color: rgb(24, 95, 155);
}

.van-uploader >>> .van-uploader__upload-text {
  color: rgb(24, 95, 155);
  font-weight: 500;
}

.van-uploader >>> .van-uploader__preview-image {
  border-radius: 8px;
}

/* 日期选择器 */
.van-datetime-picker >>> .van-picker__confirm {
  color: rgb(24, 95, 155);
  font-weight: 600;
}

.van-datetime-picker >>> .van-picker__cancel {
  color: #999;
}

/* 弹出层 */
.van-popup {
  border-radius: 16px 16px 0 0;
}

.van-popup >>> .van-picker__toolbar {
  background: linear-gradient(
    135deg,
    rgb(24, 95, 155) 0%,
    rgb(34, 115, 175) 100%
  );
}

.van-popup >>> .van-picker__title,
.van-popup >>> .van-picker__confirm,
.van-popup >>> .van-picker__cancel {
  color: #fff;
}

/* 选择联系人弹窗 */
.van-action-sheet >>> .van-action-sheet__header {
  background: linear-gradient(
    135deg,
    rgb(24, 95, 155) 0%,
    rgb(34, 115, 175) 100%
  );
  color: #fff;
  font-weight: 600;
}

.van-action-sheet >>> .van-cell:hover {
  background: #f8f9fa;
}

.van-action-sheet >>> .van-cell:active {
  background: rgba(24, 95, 155, 0.1);
}

/* 搜索框 */
.van-search {
  background: #f5f5f5;
  border-radius: 8px;
  margin: 10px;
}

.van-search >>> .van-search__content {
  background: #fff;
  border-radius: 6px;
}

.van-search >>> .van-icon-search {
  color: rgb(24, 95, 155);
}

/* 按钮组 */
.van-button--info {
  background: linear-gradient(
    135deg,
    rgb(34, 115, 175) 0%,
    rgb(44, 135, 195) 100%
  );
  border: none;
  border-radius: 6px;
  font-weight: 500;
  box-shadow: 0 2px 8px rgba(34, 115, 175, 0.3);
}

.van-button--danger {
  background: linear-gradient(135deg, #ef5350 0%, #e53935 100%);
  border: none;
  border-radius: 6px;
  font-weight: 500;
  box-shadow: 0 2px 8px rgba(239, 83, 80, 0.3);
}

.van-button:active {
  transform: scale(0.95);
}

/* 分隔线 */
hr {
  border: none;
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(24, 95, 155, 0.2),
    transparent
  );
  margin: 20px 0;
}

/* 卡片样式 */
.player-card {
  background: #fff;
  border-radius: 12px;
  margin: 10px;
  padding: 15px;
  box-shadow: 0 2px 12px rgba(24, 95, 155, 0.1);
  border-left: 4px solid rgb(24, 95, 155);
}

/* 响应式设计 */
@media (max-width: 375px) {
  .van-row > div {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .radio-group {
    flex-direction: column;
    gap: 12px;
  }
}

/* 滚动条美化 */
::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-thumb {
  background: linear-gradient(
    135deg,
    rgb(24, 95, 155) 0%,
    rgb(34, 115, 175) 100%
  );
  border-radius: 3px;
}

::-webkit-scrollbar-track {
  background: #f5f5f5;
}
</style>



// WEBPACK FOOTER //
// src/components/commonCom/ReportRyInfoCom.vue